import { DesmonstracoesAtuariaisDaPBB } from './lista-documentos/demonstracoes-atuariais-da-pbb';
import { DesmonstracoesAtuariaisDaPBDC } from './lista-documentos/demonstracoes-atuariais-da-pbdc';
import { DesmonstracoesAtuariaisDaPCD } from './lista-documentos/demonstracoes-atuariais-da-pcd';
import { Estatutos } from './lista-documentos/estatutos';
import { ExtratoAtlasConselhoDeliberativo } from './lista-documentos/extrato-atas-conselho-deliberativo';
import { ExtratoAtlasConselhoFiscal } from './lista-documentos/extrato-atas-conselho-fiscal';
import { LinksPDF } from './lista-documentos/links-pdf';
import { ManisfestacaoConselhoFsical } from './lista-documentos/manifestacao-conselho-fiscal';
import { PbbDocumentos } from './lista-documentos/pbb-documentos';
import { PbbRegulamentos } from './lista-documentos/pbb-regulamentos';
import { PbdcDocumentos } from './lista-documentos/pbdc-documentos';
import { PbdcRegulamentos } from './lista-documentos/pbdc-regulamentos';
import { PcdDocumentos } from './lista-documentos/pcd-documentos';
import { PcdRegulamentos } from './lista-documentos/pcd-regulamentos';
import { RegimentosInternos } from './lista-documentos/regimentos-internos-pdf';
import { RelatorioAassembleia } from './lista-documentos/relatorio-assembleia';

export class AcessoPDFIdentificacao {


    static acessoPDFIdentificacaoLista: AcessoPDFIdentificacao[] = [
        { id: 'cci', descricao: 'Comunicados / Informes', listaDocumentos: [] },
        { id: 'cdapbb', descricao: 'Demonstrações Atuariais - DA - PBB', listaDocumentos: DesmonstracoesAtuariaisDaPBB.desmonstracoesAtuariaisDaPBBLista },
        { id: 'cdapbdc', descricao: 'Demonstrações Atuariais - DA - PBDC', listaDocumentos: DesmonstracoesAtuariaisDaPBDC.desmonstracoesAtuariaisDaPBDCLista },
        { id: 'cdapcd', descricao: 'Demonstrações Atuariais - DA - PCD', listaDocumentos: DesmonstracoesAtuariaisDaPCD.desmonstracoesAtuariaisDaPCDLista },
        { id: 'cmcf', descricao: 'Manifestação do Conselho Fiscal', listaDocumentos: ManisfestacaoConselhoFsical.manisfestacaoConselhoFsicalLista },
        { id: 'cra', descricao: 'Relatórios Assembléias ', listaDocumentos: RelatorioAassembleia.relatorioAassembleiaLista },
        { id: 'clpdf', descricao: 'Documentos Gerais', listaDocumentos: LinksPDF.linksPDFLista },
        { id: 'pbbdoc', descricao: 'PBB Documentos', listaDocumentos: PbbDocumentos.pbbDocumentosLista },
        { id: 'pbdcdoc', descricao: 'PBDC Documentos', listaDocumentos: PbdcDocumentos.pbbDocumentosLista },
        { id: 'pcddoc', descricao: 'PCD Documentos', listaDocumentos: PcdDocumentos.pcdDocumentosLista },
        { id: 'i_pbbr_ar', descricao: 'PBB Regulamentos', listaDocumentos: PbbRegulamentos.pbbRegulamentosLista },
        { id: 'i_pbdc_ar', descricao: 'PBDC Regulamentos', listaDocumentos: PbdcRegulamentos.pbdcRegulamentosLista },
        { id: 'i_pcdi_ar', descricao: 'PCD Regulamentos', listaDocumentos: PcdRegulamentos.pcdRegulamentosLista },
        { id: 'i_e_ar', descricao: 'Estatutos', listaDocumentos: Estatutos.estatutosLista },
        { id: 'i_ri_ar', descricao: 'Regimentos Internos', listaDocumentos: RegimentosInternos.regimentosInternosLista },
        { id: 'eacd_ar', descricao: 'Extrato das Atas do Conselho Deliberativo', listaDocumentos: ExtratoAtlasConselhoDeliberativo.extratoAtlasConselhoDeliberativoLista },
        { id: 'eacf_ar', descricao: 'Extrato das Atas do Conselho Fiscal', listaDocumentos: ExtratoAtlasConselhoFiscal.extratoAtlasConselhoFiscalLista }
    ]

    constructor(
        public id: string,
        public descricao: string,
        public listaDocumentos: any[] = []
    ) {



    }




}




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/dados-documentos-institucional/acesso-pdfs-identificadores.ts